import { useLocation } from "react-router-dom";
import { useStorefrontTenant } from "context/StorefrontTenantContext";
import RegisterCustomer from "pages/customer/RegisterCustomer";
import { STOREFRONT_TENANTS } from "./registry";

/**
 * Tenant-aware registration routing.
 * Tenants with pages.register (e.g. eds) use their own create-account flow.
 * Distributor apply routes keep the full shared application wizard.
 */
export default function StorefrontRegisterRoute() {
  const location = useLocation();
  const { tenantKey } = useStorefrontTenant();
  const pathname = String(location.pathname || "").toLowerCase();
  const isDistributorApply =
    pathname === "/distributor/apply" ||
    pathname === "/partners/apply" ||
    pathname === "/m/distributor/apply" ||
    pathname === "/m/partners/apply";

  if (isDistributorApply) {
    return <RegisterCustomer />;
  }

  const key = String(tenantKey || "").toLowerCase();
  const TenantRegister = STOREFRONT_TENANTS[key]?.pages?.register;
  if (TenantRegister) {
    return <TenantRegister />;
  }

  return <RegisterCustomer />;
}
